import { z } from "zod";
import { auditActorFields } from "../common/audit.js";
import { pagedResponse, paginationQuerySchema } from "../common/pagination.js";
import { booleanQueryParam } from "../common/query-params.js";
export const productInfo = z.object({
    id: z.string().uuid(),
    categoryId: z.string().uuid().nullable(),
    categoryName: z.string().nullable(),
    categoryCode: z.string().nullable(),
    articleCode: z.string().nullable(),
    externalRef: z.string().nullable(),
    name: z.string(),
    brand: z.string().nullable(),
    subBrand: z.string().nullable(),
    variantName: z.string().nullable(),
    packSize: z.string().nullable(),
    packWidthMm: z.number().int().nullable(),
    packHeightMm: z.number().int().nullable(),
    packDepthMm: z.number().int().nullable(),
    packWeightG: z.number().int().nullable(),
    packagingType: z.string().nullable(),
    packagingLabel: z.string().nullable(),
    orientation: z.string().nullable(),
    primaryImageUri: z.string().nullable(),
    price: z.number().finite().nonnegative().nullable().optional(),
    mrp: z.number().finite().nonnegative().nullable().optional(),
    currency: z.string().regex(/^[A-Z]{3}$/).nullable().optional(),
    isPriority: z.boolean(),
    isActive: z.boolean(),
    metadata: z.record(z.unknown()),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    ...auditActorFields,
});
export const createProductRequest = z.object({
    categoryId: z.string().uuid().nullish(),
    articleCode: z.string().max(100).nullish(),
    externalRef: z.string().max(255).nullish(),
    name: z.string().min(1).max(255),
    brand: z.string().max(128).nullish(),
    subBrand: z.string().max(128).nullish(),
    variantName: z.string().max(128).nullish(),
    packSize: z.string().max(64).nullish(),
    packWidthMm: z.number().int().positive().nullish(),
    packHeightMm: z.number().int().positive().nullish(),
    packDepthMm: z.number().int().positive().nullish(),
    packWeightG: z.number().int().positive().nullish(),
    packagingType: z.string().max(64).nullish(),
    packagingLabel: z.string().max(255).nullish(),
    orientation: z.string().max(64).nullish(),
    price: z.number().nonnegative().nullish(),
    mrp: z.number().nonnegative().nullish(),
    currency: z.string().regex(/^[A-Z]{3}$/).nullish(),
    isPriority: z.boolean().default(false),
    isActive: z.boolean().default(true),
    metadata: z.record(z.unknown()).default({}),
});
export const updateProductRequest = createProductRequest.partial().refine((v) => Object.keys(v).length > 0, { message: "At least one field required" });
export const listProductsQuery = paginationQuerySchema.extend({
    categoryId: z.string().uuid().optional(),
    brand: z.string().optional(),
    isActive: booleanQueryParam.optional(),
    search: z.string().max(255).optional(),
    /** When true, return only products with no image (primary_image_uri IS NULL). */
    imageless: booleanQueryParam.optional(),
});
export const productsListResponse = pagedResponse(productInfo);
//# sourceMappingURL=products.schemas.js.map